import React from 'react';
import { defineMessages } from 'react-intl-next';

import AiGenerativeAudioBriefingIcon from '@atlaskit/icon-lab/core/ai-generative-audio-briefing';
import TextAudioTranscriptIcon from '@atlaskit/icon-lab/core/text-audio-transcript';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import LinkIcon from '@atlaskit/icon/core/link';

import {
	type AudioFeature,
	AudioFeatureType,
	type AudioFeatureMenuItemKey,
} from '@atlassian/ai-audio';

import { CustomizePanel } from '../components/platform/panels/customize/CustomizePanel.tsx';
import { SourcesPanel } from '../components/platform/panels/sources/SourcesPanel.tsx';

const i18n = defineMessages({
	narrationLabel: {
		id: 'audio.audio-features.narration-label',
		defaultMessage: 'Narration',
		description: 'Label for the narration feature',
	},
	briefingLabel: {
		id: 'audio.audio-features.briefing-label',
		defaultMessage: 'Briefing',
		description: 'Label for the briefing feature',
	},
	narrationAccessibleLabel: {
		id: 'audio.audio-features.narration-accessible-label',
		defaultMessage: 'audio narration',
		description: 'Accessible label for the narration feature',
	},
	briefingAccessibleLabel: {
		id: 'audio.audio-features.briefing-accessible-label',
		defaultMessage: 'audio briefing',
		description: 'Accessible label for the briefing feature',
	},
	customizeLabel: {
		id: 'audio.audio-features.customize-menu-item-label',
		defaultMessage: 'Customize',
		description: 'Label for the customize menu item',
	},
	manageSourcesLabel: {
		id: 'audio.audio-features.manage-sources-menu-item-label',
		defaultMessage: 'Manage sources',
		description: 'Label for the manage sources menu item',
	},
	manageSourcesPanelHeader: {
		id: 'audio.audio-features.manage-sources-panel-header',
		defaultMessage: 'Sources',
		description: 'Header for the sources panel',
	},
});

export const audioFeatures: AudioFeature[] = [
	{
		name: AudioFeatureType.BRIEFING,
		translationString: i18n.briefingLabel,
		accessibleLabel: i18n.briefingAccessibleLabel,
		icon: AiGenerativeAudioBriefingIcon,
		menuConfig: {
			items: [
				{
					id: 'customize' as AudioFeatureMenuItemKey,
					onClick: () => {},
					title: i18n.customizeLabel,
					icon: CustomizeIcon({ label: '' }),
					renderPanel: {
						header: i18n.customizeLabel,
						body: () => <CustomizePanel />,
					},
				},
				{
					id: 'manageSources' as AudioFeatureMenuItemKey,
					onClick: () => {},
					title: i18n.manageSourcesLabel,
					icon: LinkIcon({ label: '' }),
					renderPanel: {
						header: i18n.manageSourcesPanelHeader,
						body: () => <SourcesPanel />,
					},
				},
			],
		},
	},
	{
		name: AudioFeatureType.NARRATION,
		translationString: i18n.narrationLabel,
		accessibleLabel: i18n.narrationAccessibleLabel,
		icon: TextAudioTranscriptIcon,
	},
];
